/**
 * add_to_stage, remove_from_stage events with fake bubbles
 * https://github.com/CreateJS/EaselJS/pull/472/files
 */

import { CREATEJS_UTILITIES_LOGGER } from "../../../..";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".spritesheets");

// change SpriteSheetUtils.extractFrame to return canvas, and add cache to spriteSheet object
createjs.SpriteSheetUtils.extractFrame = function (spriteSheet, frameOrAnimation) {
    let cached: Map<any, any> = (spriteSheet as any)["_cachedCanvas"] = (spriteSheet as any)["_cachedCanvas"] || new Map();
    let canvas: any, savedFrameOrAnimation = frameOrAnimation;
    if (canvas = cached.get(frameOrAnimation)) {
        return canvas;
    }
    if (isNaN(frameOrAnimation as number)) {
        frameOrAnimation = spriteSheet.getAnimation(frameOrAnimation as string).frames[0];
    }
    let data = spriteSheet.getFrame(frameOrAnimation as number);
    if (!data) { return null; }
    let r = data.rect;
    canvas = document.createElement("canvas");
    canvas.width = r.width;
    canvas.height = r.height;
    canvas.getContext("2d")!.drawImage(data.image, r.x, r.y, r.width, r.height, 0, 0, r.width, r.height);
    cached.set(savedFrameOrAnimation, canvas);
    return canvas;
};

(createjs.SpriteSheet.prototype as any)["_parseData"] = function (data: any) {
    let i, l, o, a: any[];

    if (data == null) { return; }

    this.framerate = data.framerate || 0;

    // parse images:
    if (data.images && (l = data.images.length) > 0) {
        a = this._images = [];
        for (i = 0; i < l; i++) {
            let src: string | undefined;
            let img = data.images[i];
            if (typeof img == "string") {
                src = img;
                img = document.createElement("img");
                img.src = src;
            } else if (img instanceof ArrayBuffer) {
                // try to decode binary
                let Decoder = (window as any).BPGDecoder;
                if (Decoder) {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d")!;
                    const b: any = new Decoder(ctx);
                    const timer = `bpg-${data.sourceSize.w}-${data.sourceSize.h}`;
                    const start = performance.now();
                    b._onload({ response: img });
                    canvas.width = b.imageData.width;
                    canvas.height = b.imageData.height;
                    ctx.putImageData(b.imageData, 0, 0);
                    const single = performance.now() - start;
                    (window as any).bpgTotal = (window as any).bpgTotal || 0;
                    (window as any).bpgTotal += single;
                    logger.info(timer, `single ${single}ms`, `total ${(window as any).bpgTotal / 1000}s`);
                    img = canvas;
                }
            }
            a.push(img);
            if (!img.getContext && !img.naturalWidth) {
                this._loadCount++;
                this.complete = false;
                (function (o, src) { img.onload = function () { o._handleImageLoad(src); } })(this, src);
                (function (o, src) { img.onerror = function () { o._handleImageError(src); } })(this, src);
            }
        }
    }

    // parse frames:
    if (data.frames == null) { // nothing
    } else if (Array.isArray(data.frames)) {
        this._frames = [];
        a = data.frames;
        for (i = 0, l = a.length; i < l; i++) {
            const arr = a[i];
            this._frames.push({ image: this._images[arr[4] ? arr[4] : 0], rect: new createjs.Rectangle(arr[0], arr[1], arr[2], arr[3]), regX: arr[5] || 0, regY: arr[6] || 0 });
        }
    } else {
        o = data.frames;
        this._frameWidth = o.width;
        this._frameHeight = o.height;
        this._regX = o.regX || 0;
        this._regY = o.regY || 0;
        this._spacing = o.spacing || 0;
        this._margin = o.margin || 0;
        this._numFrames = o.count;
        if (this._loadCount == 0) { this._calculateFrames(); }
    }

    // parse animations:
    this._animations = [];
    if ((o = data.animations) != null) {
        this._data = {};
        let name;
        for (name in o) {
            const anim: any = { name: name };
            const obj = o[name];
            if (typeof obj == "number") { // single frame
                a = anim.frames = [obj];
            } else if (Array.isArray(obj)) { // simple
                if (obj.length == 1) { anim.frames = [obj[0]]; }
                else {
                    anim.speed = obj[3];
                    anim.next = obj[2];
                    a = anim.frames = [];
                    for (i = obj[0]; i <= obj[1]; i++) {
                        a.push(i);
                    }
                }
            } else { // complex
                anim.speed = obj.speed;
                anim.next = obj.next;
                const frames = obj.frames;
                a = anim.frames = (typeof frames == "number") ? [frames] : frames.slice(0);
            }
            if (anim.next === true || anim.next === undefined) { anim.next = name; } // loop
            if (anim.next === false || (a!.length < 2 && anim.next == name)) { anim.next = null; } // stop
            if (!anim.speed) { anim.speed = 1; }
            this._animations.push(name);
            this._data[name] = anim;
        }
    }
};
